/* eslint-disable react-hooks/exhaustive-deps */
//react imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

//component imports
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  editReimbursementAccount,
  resetEditReimbursementAccount,
} from "../../../../../redux/features/accounts/ReimburseAccount";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import AdditionalRecipients from "../../../../../components/_utils/AccountCreationComponents/AdditionalRecipients";
import AdditionalRecipientCreate from "../../../../../components/AdditionalRecipientCreate";

const ReimbursementRecipient = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;
  const currentDetail = useLocation().state;

  const { reimbursementAccountEditData, reimbursementAccountEditLoading } =
    useSelector((state) => state.ReimburseAccount);

  // usestates
  const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [updateActive, setUpdateActive] = useState(false);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [tempRecipients, setTempRecipients] = useState([]);
  const [originalRecipients, setOriginalRecipients] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState([]);
  const [recipientsDispatch, setRecipientsDispatch] = useState(
    currentDetail?.recipient_email,
  );

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      nextHoverOption: "black",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsEnabled: !isUpdateDisabled,
      stepperText: "Recipients",
      nextIsLoading: reimbursementAccountEditLoading,
      nextLoaderNeeded: true,
    },
  ];

  const handleConfirmRecipients = () => {
    if (recipientButtonDisabled) return;
    setRecipientsDispatch(tempRecipients);
    setShowAdditionalSection(false);
  };

  useEffect(() => {
    const changed =
      JSON.stringify(tempRecipients) !== JSON.stringify(originalRecipients);

    setRecipientButtonDisabled(!changed);
  }, [tempRecipients, originalRecipients]);

  const openAdditionalRecipients = () => {
    const confirmed = recipientsDispatch || [];
    setTempRecipients(confirmed);
    setOriginalRecipients(confirmed);
    setShowAdditionalSection(true);
  };

  const initialRecipientCount = GlobalConfiguration.lengthCheckZero;

  const handleUpdateAccount = async () => {
    const response = await dispatch(
      editReimbursementAccount({
        id: id,
        recipient_email: [...recipientsDispatch].join(","),
      }),
    );

    if (response?.error?.message === "Rejected") {
      setButtonDisable(false);
      setUpdateActive(false);
    } else {
      setButtonDisable(true);
    }
  };

  const handleBack = () => {
    if (!isUpdateDisabled) {
      setOpenPopEdit(true);
    } else {
      navigate(GlobalConfiguration?.navigate_back);
    }
  };

  const handleConfirm = () => {
    navigate(GlobalConfiguration?.navigate_back);
  };

  useEffect(() => {
    if (reimbursementAccountEditData?.status === true) {
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/recipients_edit_success/${id}`,
        {
          replace: true,
        },
      );
      dispatch(resetEditReimbursementAccount());
    }
  }, [reimbursementAccountEditData]);

  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (
        e.key === "Enter" &&
        !isUpdateDisabled &&
        !buttonDisable &&
        !updateActive
      ) {
        handleUpdateAccount();
      }
    };

    document.addEventListener("keydown", handleEnterKeyPress);

    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [isUpdateDisabled, buttonDisable, updateActive]);

  useEffect(() => {
    const existingRecipients = currentDetail?.recipient_email ?? [];
    const selectedRecipients = recipientsDispatch ?? [];

    const isSame =
      existingRecipients.join(",") === selectedRecipients.join(",");

    setIsUpdateDisabled(isSame);
  }, [currentDetail?.recipient_email, recipientsDispatch]);

  return (
    <div className="edit-1024-con bg-primary-bg">
      <div
        className="edit-category-main"
        style={{
          overflowY: "scroll",
          scrollbarWidth: "none",
        }}
      >
        {openPopEdit && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle={"Confirm leaving this page?"}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              subtext="Leaving this page will not update the changes made."
              btnOneText="Stay"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => setOpenPopEdit(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleConfirm}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        {showAdditionalSection && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <AdditionalRecipientCreate
              finalRecipients={currentDetail.recipient_email}
              initialRecipientCount={initialRecipientCount}
              setShowAdditionalSection={setShowAdditionalSection}
              handleConfirm={handleConfirmRecipients}
              recipients={tempRecipients}
              setRecipients={setTempRecipients}
              buttonDisabled={recipientButtonDisabled}
              setButtonDisabled={setRecipientButtonDisabled}
              additionalChip={additionalChip}
              setAdditionalChip={setAdditionalChip}
            />
          </div>
        )}
        <div className="h-navbar-breadcrumb-height hidden Qmd:block"></div>
        <div className="main_edit_category_stepper_div Qmd:relative">
          <PrimaryStepper
            activeStep={0}
            handleForwardAction={handleUpdateAccount}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
        <div className="w-width-full relative Qmd:hidden block">
          <TopNavComponent
            isFormattingNotRequired
            topNavSubText="Recipients"
            topNavHeader={"Reimbursement Account"}
            topNavCtaBtn1Props={{
              btnText: "Update",
              btnType: "button",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              inActiveVariantNeeded: true,
              disabledBgColor: "var(--text-disabled)",
              isDisabled: !(
                !isUpdateDisabled &&
                !buttonDisable &&
                !updateActive
              ),
              handleFunction:
                !isUpdateDisabled && !buttonDisable && !updateActive
                  ? handleUpdateAccount
                  : () => {},
            }}
          />
        </div>
        <div className="px-padding-md lg:px-padding-base mt-margin-base Qsmd:mt-margin-xl pt-padding-base Qsmd:pt-padding-xl">
          <div className="w-width-full Qlg:w-width-md ">
            <div className="flex flex-col Qsmd:pt-padding-md">
              <div className="mt-margin-lg Qmd:mt-margin-base rounded-border-radius-md">
                <AdditionalRecipients
                  setShowAdditionalSection={openAdditionalRecipients}
                  recipients={recipientsDispatch}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReimbursementRecipient;
